import { WallTile } from "./WallTile";
export function autoWall(root) {
    console.time("wall");
    const explored = new Set();
    const wallsToLink = new Set();
    let maxExplore = 1000;
    explored.add(root);
    console.time("wallExplore");
    for (let tile of explored) {
        for (let i = 0; i < 4; i++) {
            const edge = tile.getReference(i);
            if (edge) {
                const nextTile = edge.to;
                if (nextTile instanceof WallTile || explored.has(nextTile)) {
                    continue;
                }
                explored.add(nextTile);
            }
            else {
                const nt = new WallTile();
                wallsToLink.add(nt);
                nt.link(2 /* left */, tile, i);
            }
        }
    }
    console.timeEnd("wallExplore");
    console.time("wallLink");
    for (let wall of wallsToLink) {
        const base = wall.getView(0).getNeighbor(2 /* left */);
        if (!base)
            continue;
        for (let dir of [3 /* top */, 1 /* bottom */]) {
            if (wall.getReference(dir))
                continue;
            const nextBase = base.getNeighbor(dir);
            if (nextBase.tile instanceof WallTile)
                continue;
            const targWall = nextBase.getNeighbor(0 /* right */);
            if (!(targWall.tile instanceof WallTile))
                continue;
            wall.getView(0).link(dir, targWall);
        }
    }
    console.timeEnd("wallLink");
    for (let wall of wallsToLink) {
        const wallShade = wall.wallShade;
        for (let dir of [3 /* top */, 1 /* bottom */]) {
            let view = wall.getView(0).getNeighbor(dir);
            while (view && view.tile instanceof WallTile && view.tile !== wall) {
                wallsToLink.delete(view.tile);
                view.tile.wallShade = wallShade;
                view = view.getNeighbor(dir);
            }
        }
    }
    console.timeEnd("wall");
}



//////////////////
// WEBPACK FOOTER
// ./src/autoWall.ts
// module id = 18
// module chunks = 0